import React from 'react';
import useFadeUp from '../../hooks/useFadeUp';

const FadeUp = ({ children, className = '', delay = 0, as: Component = 'div', ...rest }) => {
  const ref = useFadeUp(delay);

  return (
    <Component ref={ref} className={`fade-up ${className}`.trim()} {...rest}>
      {children}
    </Component>
  );
};

export default FadeUp;
